/*!jslint
  this
*/
jQuery(function($) {
  "use strict";
  
  $(document).on("click","#mobile-menu .menu-item a",function(e) {
    e.preventDefault();
    var goto =  $(this).attr("href");
    $("html, body").animate({ scrollTop: $(goto).offset().top }, 200);
    $('#mobileModal').modal('hide');
  });

  $(document).on("click",".site-branding a",function(e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
  
  if($('.hp-logo').length) {
    $(document).ready(function(){
      $('.hp-logo').slick({
        arrows   : false,
        dots     : false,
       // infinite: true,
        variableWidth: true,
        // slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase:'linear',
        speed: 4500,
        responsive: [
  
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
  }
});
